/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ObjectV6_ObjectType {
    PERSON = 'person',
    CHALLENGED = 'challenged',
    WHEELCHAIR = 'wheelchair',
    DOG = 'dog',
    BIKE = 'bike',
    ITEM = 'item',
    CAR = 'car',
    MOTORBIKE = 'motorbike',
}
